import {
    postProductionAnalysisData,
    postSalesAnalysisData,
    getSexAndCompanySummaryChart,
    postSalesmanAnalysisData
} from "./api/charts"

class ChartDataService {
    async getSexAndCompanySummaryChart(){
        //return http.get("/sexandcompanysummarychart");
        return await getSexAndCompanySummaryChart()
    }

    async getProductAnalysisData(insurance_company_id, company_name){
        return await postProductionAnalysisData({insurance_company_id, company_name})
    }

    async getSalesAnalysisData(year, month){
        return await postSalesAnalysisData({year, month})
    }

    async getSalesmanAnalysisData(salesman_id, years){
        return await postSalesmanAnalysisData({salesman_id, years})
    }
}

export default new ChartDataService();